export default "__VITE_ASSET__aeZpGlm$__"